var cachePromise = new Map();
var getCachePromise = function (cacheKey) {
    return cachePromise.get(cacheKey);
};
var setCachePromise = function (cacheKey, promise) {
    // Should cache the same promise, cannot be promise.finally
    // Because the promise.finally will change the reference of the promise
    cachePromise.set(cacheKey, promise);
    // no use promise.finally for compatibility
    promise
        .then(function (res) {
        cachePromise.delete(cacheKey);
        return res;
    })
        .catch(function () {
        cachePromise.delete(cacheKey);
    });
};
export { getCachePromise, setCachePromise };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FjaGVQcm9taXNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvcmUvdXRpbHMvY2FjaGVQcm9taXNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLElBQU0sWUFBWSxHQUFHLElBQUksR0FBRyxFQUEyQixDQUFDO0FBRXhELElBQU0sZUFBZSxHQUFHLFVBQUMsUUFBbUI7SUFDMUMsT0FBTyxZQUFZLENBQUMsR0FBRyxDQUFDLFFBQVEsQ0FBQyxDQUFDO0FBQ3BDLENBQUMsQ0FBQztBQUVGLElBQU0sZUFBZSxHQUFHLFVBQUMsUUFBbUIsRUFBRSxPQUFxQjtJQUNqRSwyREFBMkQ7SUFDM0QsdUVBQXVFO0lBQ3ZFLFlBQVksQ0FBQyxHQUFHLENBQUMsUUFBUSxFQUFFLE9BQU8sQ0FBQyxDQUFDO0lBRXBDLDJDQUEyQztJQUMzQyxPQUFPO1NBQ0osSUFBSSxDQUFDLFVBQUMsR0FBRztRQUNSLFlBQVksQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLENBQUM7UUFDOUIsT0FBTyxHQUFHLENBQUM7SUFDYixDQUFDLENBQUM7U0FDRCxLQUFLLENBQUM7UUFDTCxZQUFZLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFDO0lBQ2hDLENBQUMsQ0FBQyxDQUFDO0FBQ1AsQ0FBQyxDQUFDO0FBRUYsT0FBTyxFQUFFLGVBQWUsRUFBRSxlQUFlLEVBQUUsQ0FBQyJ9